import { connect } from "react-redux";
import DrawerHeader from "./DrawerHeader";

const mapStateToProps = (state, ownProps) => {
  return {
    date: state.prerequisites.config["CI_STRING_TIME"] || "??",
    build: String(state.prerequisites.config["CI_BUILD_ID"]) || "??",
    mode: state.prerequisites.config["MODE"]
  };
};

const DrawerHeaderContainer = connect(mapStateToProps)(DrawerHeader);

export default DrawerHeaderContainer;



// WEBPACK FOOTER //
// ./src/DrawerHeaderContainer.js